import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthorizationService, IPrincipal } from '../../authorization/authorization.service';

@Component({
  selector: 'app-products-modal',
  templateUrl: './products-modal.component.html',
  styleUrls: ['./products-modal.component.scss'],
})
export class ProductsModalComponent {
  public email: string | null | undefined;
  @Input() showNote: boolean = false;

  constructor(
    private _activeModal: NgbActiveModal,
    private _authorization: AuthorizationService,
  ) {
    _authorization.principal$.subscribe((user: IPrincipal) => {
      this.email = user.identity.email;
    });
  }

  public dismiss(): void {
    this._activeModal.dismiss();
  }
}
